import { useEffect, useState } from 'react';
import { type ConnectedProps, connect } from 'react-redux';
import {
  StyledAccountInfoContainer,
  StyledBoxShadowText,
  StyledButtonContainer,
  StyledCopiedText,
  StyledReferralCode,
  StyledReferralCodeContent,
  StyledReferralCodeInstructions,
} from './styles';
import { StyledStepContent, StyledSubheaderText } from '@/components/checkout/uielements';
import StringAccessor from '@/components/cmsConfig/stringAccessor';
import { StyledPrimaryButton } from '@/components/uielements/primaryButton/styles';
import { type RootState } from '@/types/app';
import { copyToClipboard } from '@/utils/global';

export const containerId = 'referral-code-container';

const _ReferralCode = ({ me }: ReduxProps) => {
  const [copied, setCopied] = useState<string | null>(null);

  useEffect(() => {
    // Copy code to clipboard and display 'Copied!' message
    if (copied) {
      // @ts-expect-error ensure that `copied` is defined.
      copyToClipboard(copied).catch((error) => console.log(error));

      // Remove message after 3 seconds
      setTimeout(() => setCopied(null), 3000);
    }
  }, [copied]);

  // Only display if referral code exists
  if (!me?.referral_code) {
    return null;
  }

  return (
    <StyledStepContent $enabled={true} data-testid={containerId}>
      <StyledAccountInfoContainer>
        <StringAccessor
          accessor="account.referral_code_instructions_header"
          tag={StyledSubheaderText}
        />
        <StringAccessor
          accessor="account.referral_code_instructions"
          tag={StyledReferralCodeInstructions}
        />
        <StyledReferralCodeContent>
          <StyledReferralCode>
            <StringAccessor tag="p" accessor="account.referral_code_header" />
            <StyledBoxShadowText>{me.referral_code}</StyledBoxShadowText>
          </StyledReferralCode>
          <StyledButtonContainer>
            <StyledPrimaryButton
              data-css-override="StyledPrimaryButton"
              size="small"
              onClick={() => setCopied(me.referral_code)}
            >
              Copy
            </StyledPrimaryButton>
            {copyToClipboard(copied) && <StyledCopiedText>Copied!</StyledCopiedText>}
          </StyledButtonContainer>
        </StyledReferralCodeContent>
      </StyledAccountInfoContainer>
    </StyledStepContent>
  );
};

const mapStateToProps = (state: RootState) => ({
  me: state.app.me.data,
});
const connector = connect(mapStateToProps);
type ReduxProps = ConnectedProps<typeof connector>;
export const ReferralCode = connector(_ReferralCode);
